import { css } from '@emotion/react'
import { mq } from '@/styles'

export const styles = () => ({
  form: {
    main: css``,

    content: {
      main: css`
        display: flex;
        justify-content: center;
      `,
      submit: css`
        ${mq.mobile(css`
          width: 100%;
        `)}

        & > button {
          width: 380px;

          ${mq.mobile(css`
            width: 100%;
          `)}
        }
      `,
    },
  },
})
